function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { twMerge } from "@stereoagency/tailwind-config";
import React, { forwardRef, useState, useEffect, useRef } from "react";
import { Body } from "../Body";
function $FormSelect(param) {
    var label = param.label, value = param.value, options = param.options, onChange = param.onChange, required = param.required, error = param.error, _param_className = param.className, className = _param_className === void 0 ? "" : _param_className;
    var _options_find;
    var ref = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), openDropdown = _useState[0], setOpenDropdown = _useState[1];
    useEffect(function() {
        var handleClickOutside = function(event) {
            var _ref_current;
            if ((ref === null || ref === void 0 ? void 0 : ref.current) && !(ref === null || ref === void 0 ? void 0 : (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.contains(event.target))) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener("click", handleClickOutside, true);
        return function() {
            document.removeEventListener("click", handleClickOutside, true);
        };
    }, []);
    var onClickSelect = function() {
        setOpenDropdown(!openDropdown);
    };
    var onSelectOptions = function(newValue) {
        if (onChange) {
            onChange(newValue);
        }
        setOpenDropdown(false);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "relative w-full"
    }, label ? /*#__PURE__*/ React.createElement("p", {
        className: "font-heading font-semibold mb-4"
    }, label, required ? " *" : "") : null, /*#__PURE__*/ React.createElement("div", {
        ref: ref,
        className: "relative w-full"
    }, /*#__PURE__*/ React.createElement("div", {
        role: "button",
        tabIndex: 0,
        className: twMerge("flex justify-between items-center bg-white px-5 py-6 gap-x-3 border border-neutral-900 border-opacity-50 rounded-md cursor-pointer", className),
        onClick: onClickSelect,
        onKeyDown: onClickSelect
    }, /*#__PURE__*/ React.createElement("div", {
        className: "flex-1"
    }, /*#__PURE__*/ React.createElement(Body, {
        as: "p",
        className: "font-heading font-semibold"
    }, ((_options_find = options.find(function(option) {
        return option.value === value;
    })) === null || _options_find === void 0 ? void 0 : _options_find.label) || value)), /*#__PURE__*/ React.createElement("div", {
        className: "flex justify-center items-center w-5.5 h-5.5"
    }, /*#__PURE__*/ React.createElement("svg", {
        width: "11",
        height: "7",
        viewBox: "0 0 11 7",
        fill: "none"
    }, /*#__PURE__*/ React.createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0.730169 0.709376C1.02875 0.422281 1.50353 0.43159 1.79063 0.730169L5.5 4.66792L9.20938 0.730169C9.49647 0.431591 9.97125 0.422281 10.2698 0.709376C10.5684 0.996471 10.5777 1.47125 10.2906 1.76983L6.04063 6.26983C5.89922 6.41689 5.70401 6.5 5.5 6.5C5.29599 6.5 5.10078 6.41689 4.95938 6.26983L0.709376 1.76983C0.422281 1.47125 0.431591 0.996471 0.730169 0.709376Z",
        fill: "#272835"
    })))), openDropdown ? /*#__PURE__*/ React.createElement("div", {
        className: "absolute left-0 w-full mt-2 max-h-13 bg-white overflow-y-auto p-3 rounded-md z-10 shadow-md"
    }, options.map(function(option) {
        return /*#__PURE__*/ React.createElement("div", {
            key: option.value,
            role: "button",
            tabIndex: 0,
            className: "px-2 py-3 hover:bg-button-secondary-bg-base cursor-pointer",
            onClick: function() {
                return onSelectOptions(option.value);
            },
            onKeyDown: function() {
                return onSelectOptions(option.value);
            }
        }, option.label);
    })) : null), !!error && /*#__PURE__*/ React.createElement("span", {
        className: "px-2 pt-1 text-body-small font-heading font-medium text-red-700"
    }, error));
}
var FormSelect = /*#__PURE__*/ forwardRef($FormSelect);
export default FormSelect;

//# sourceMappingURL=FormSelect.js.map